// extracted by mini-css-extract-plugin
export var askAiIcon = "_qf-9";
export var container = "_qf-0";
export var groupSeparator = "_qf-a";
export var highlight = "_qf-4";
export var resultIcon = "_qf-5";
export var resultItem = "_qf-7";
export var resultSubtitle = "_qf-3";
export var resultTitle = "_qf-2";
export var resultsList = "_qf-1";
export var searchGroup = "_qf-6";
export var selected = "_qf-8";